export enum VehicleType {
  MOTO = 1,
  AUTO = 2,
  CAMPER = 3,
  ROULOTTE = 4,
}
